import * as React from "react";
const SvgIcTablet = props => <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M21 23H3V1H21V23ZM6 19H18V5H6V19Z" fill="currentColor" /></svg>;
export default SvgIcTablet;